import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';

const SearchResult = ({result, moneyFormat, type = 'products'}) => {
  const titleClass = type === 'products' ? 'h6' : 'h4';

  return (
    <>
      <div key={result.id} className="quick-search-results__cell">
        {type === 'products' && (
          <a href={result.url} className="quick-search-results__image">
            <div className="component-image__wrapper aspect-ratio aspect-ratio--portrait">
              {result?.featured_image?.url && (
                <img
                  src={imageUrl(result.featured_image.url, 320)}
                  width={result.featured_image.width}
                  height={result.featured_image.height}
                  alt={result.featured_image.alt}
                />
              )}
            </div>
          </a>
        )}
        <div className="quick-search-results__text">
          {result.title && (
            <h4 className={`quick-search-results__title ${titleClass}`}>
              <a href={result.url}>{result.title}</a>
            </h4>
          )}

          {result.styled_text && (
            <p className="quick-search-results__query">
              <a href={result.url} aria-label={result.text} dangerouslySetInnerHTML={{__html: result.styled_text}} />
            </p>
          )}

          {result.price && (
            <p className="quick-search-results__price body-md-short">
              <span className="money">{formatMoney(result.price, moneyFormat)}</span>
            </p>
          )}
        </div>
      </div>
    </>
  );
};

SearchResult.propTypes = {
  result: PropTypes.object,
  moneyFormat: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default SearchResult;
